import { z } from "zod";
import { Commodities } from "../../commodity";

export enum AcceptedCommodity {
  Corn = "Corn",
  Soybeans = "Soybeans",
  
  Oats = "Oats",
  Sorghum = "Sorghum",
  SoybeanMeal = "Soybean meal",
  Canola = "Canola",

  Sunflowers = "Sunflowers",
  Barley = "Barley",
  Durum = "Durum",

  KcWinterWheatHrw = "KC Winter Wheat HRW",
  MnSpringHrsw = "MN Spring Wheat HRSW",
  ChicagoWinterWheatSrw = "CHI Winter Wheat SRW",
}

export const AcceptedWheatMap: Record<string, string> = {
  [AcceptedCommodity.KcWinterWheatHrw]: Commodities.WinterWheat,
  [AcceptedCommodity.MnSpringHrsw]: Commodities.MinneapolisWheat,
  [AcceptedCommodity.ChicagoWinterWheatSrw]: Commodities.WinterWheat,
};

export const AcceptedCommodityType: Record<AcceptedCommodity, Commodities> = {
  [AcceptedCommodity.Corn]: Commodities.Corn,
  [AcceptedCommodity.Soybeans]: Commodities.Soybeans,
  [AcceptedCommodity.Oats]: Commodities.Oats,
  [AcceptedCommodity.Sorghum]: "" as unknown as Commodities,
  [AcceptedCommodity.SoybeanMeal]: Commodities.SoybeanMeal,
  [AcceptedCommodity.Canola]: Commodities.Canola,
  [AcceptedCommodity.Sunflowers]: Commodities.Sunflowers,
  [AcceptedCommodity.Barley]: Commodities.Barley,
  [AcceptedCommodity.Durum]: Commodities.Durum,

  [AcceptedCommodity.KcWinterWheatHrw]: Commodities.WinterWheat,
  [AcceptedCommodity.MnSpringHrsw]: Commodities.MinneapolisWheat,
  [AcceptedCommodity.ChicagoWinterWheatSrw]: Commodities.WinterWheat,
}

export const acceptedCommodityTypes: AcceptedCommodity[] = Object.keys(AcceptedCommodityType) as AcceptedCommodity[];
export const cropProfileAcceptedCommodityTypes = acceptedCommodityTypes.filter((key: AcceptedCommodity) => {
  if (!AcceptedWheatMap[key]) { return true; }
  return key === AcceptedCommodity.MnSpringHrsw;
});

export const AcceptedCommoditiesValidation = z.enum([
  AcceptedCommodity.Corn,
  AcceptedCommodity.Soybeans,
  AcceptedCommodity.KcWinterWheatHrw,
  AcceptedCommodity.MnSpringHrsw,
  AcceptedCommodity.ChicagoWinterWheatSrw,
  AcceptedCommodity.Oats,
  AcceptedCommodity.Sorghum,
  AcceptedCommodity.SoybeanMeal,
  AcceptedCommodity.Canola,

  AcceptedCommodity.Sunflowers,
  AcceptedCommodity.Barley,
  AcceptedCommodity.Durum,
]);
